import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../Header/Header.jsx";
import style from "./style.module.css";

const Home = ({ auth = false, user }) => {

    const navigate = useNavigate();

    const [showInv, setShowInv] = React.useState(true);

    return (
        <div>
            <Header auth={auth} user={user}/>
            <div className={style.rootDiv}>
                {!auth ?
                    <button onClick={() => navigate("/minecraft/login")} className={style.loginBtn}>Login</button>
                    :
                    <div className={style.contentBox}>
                        <div className={style.leftBox}>
                            <p className={style.playerName}>{user.username}</p>
                            <div className={style.playerSkinAndArmor}>
                                <div className={style.armor}>
                                </div>
                                <img src={`https://starlightskins.lunareclipse.studio/render/ultimate/${user.mcId}/full`} alt="skin"/> {/* Sleeping */}
                            </div>
                        </div>
                        <div className={style.rightBox}>
                            <div className={style.statsAndInventory}>
                                <button onClick={() => setShowInv(false)} className={`${!showInv ? style.active : ""}`}>STATS</button>
                                <button onClick={() => setShowInv(true)} className={`${showInv ? style.active : ""}`}>INVENTORY</button>
                            </div>
                            {!showInv ?
                                <>
                                    <div className={style.statsInfo}>
                                        <p>ON/OFF:</p>
                                        <p className={style.statsValue}>ONLINE</p>
                                        <p>TIMES KICKED:</p>
                                        <p className={style.statsValue}>0</p>
                                        <p>MONEY:</p>
                                        <p className={style.statsValue}>68542$</p>
                                        <p>COINS:</p>
                                        <p className={style.statsValue}>56</p>
                                        <p>TOTAL PLAYTIME:</p>
                                        <p className={style.statsValue}>86 H</p>
                                        <p>TOTAL ACTIVE:</p>
                                        <p className={style.statsValue}>70 H</p>
                                        <p>TOTAL AFK:</p>
                                        <p className={style.statsValue}>16 H</p>
                                        <p>PLAYER KILLS:</p>
                                        <p className={style.statsValue}>13</p>
                                        <p>MOB KILLS:</p>
                                        <p className={style.statsValue}>487</p>
                                        <p>DEATHS:</p>
                                        <p className={style.statsValue}>7</p>
                                        <p>SESSIONS:</p>
                                        <p className={style.statsValue}>12</p>
                                        <p>LONGEST SESSION:</p>
                                        <p className={style.statsValue}>7 H</p>
                                        <p>LAST SEEN:</p>
                                        <p className={style.statsValue}>20.9. 2024</p>
                                        <p>REGISTERED</p>
                                        <p className={style.statsValue}>14.8. 2024</p>
                                    </div>
                                </>
                                :
                                <div className={style.inventoryDiv}>
                                    <div className={style.inventoryBox}>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                }
            </div>
        </div>
    );
};

export default Home;